<template>
  <div class="imageless-collection-list margin-top-24">
    <div
      class="imageless-collection-row flex align-end justify-between"
      v-for="(viewComponent, index) of collectionsCopy"
    >
      <div class="collection-title-wrapper">
        <text-field
          v-model="viewComponent.info.text"
          :disabled="loading"
          no-spacing
          width="full"
          :label="`Title ${getNumberByIndex(index)}`"
        ></text-field>
      </div>

      <div class="collection-selector-wrapper">
        <collection-selector
          :disabled="loading"
          :algoliaCollections="algoliaCollections"
          :selected-name="getSelectedCollectionName(viewComponent)"
          :on-select="(item) => handleCollectionSelect(item, viewComponent)"
        />
      </div>

      <div
        class="remove-button font-size-16 font-sans-regular"
        :class="{ disabled: disableRemoveButton, underline: !disableRemoveButton }"
        @click="removeItem(viewComponent)"
      >
        Remove
      </div>
    </div>

    <bulletin-button @click="addNewCollection()" :disabled="collectionsCopy.length > 15 || loading"
      >+ Add collection</bulletin-button
    >
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";
.imageless-collection-list {
  .imageless-collection-row {
    margin-bottom: 24px;

    .collection-title-wrapper {
      margin-right: 24px;
      width: 50%;
    }
    .collection-selector-wrapper {
      width: 40%;
      margin-right: 58px;
    }
  }
}

.remove-button {
  &:hover {
    cursor: pointer;
  }
  &.disabled {
    color: $color-grey;
    cursor: not-allowed;
  }
}
</style>

<script>
import { v4 as uuid } from "uuid";
import { collectionListEditorBase } from "@/views/dashboard/contentManagment/navCollectionEditorPage/collectionListEditorBase";

export default {
  mixins: [collectionListEditorBase],
  data: function () {
    return {
      collectionsCopy: [...this.collections],
    };
  },
  computed: {
    disableRemoveButton() {
      return this.collectionsCopy.length < 2;
    },
  },
  methods: {
    removeItem,
    addNewCollection,
  },
};

function removeItem(viewComponent) {
  if (this.loading) {
    return;
  }
  this.collectionsCopy = this.collectionsCopy?.filter((item) => {
    return item.localId ? item.localId !== viewComponent.localId : item.id !== viewComponent.id;
  });
}

function addNewCollection() {
  if (this.loading) {
    return;
  }

  this.collectionsCopy.push({
    info: { text: "" },
    localId: uuid(),
    component_type: "COLLECTION",
    entity_id: undefined,
  });
}
</script>
